import { saveAs } from 'file-saver';
import {
  downloadDrafts,
  downloadOfferReport,
  downloadReservationReport,
  downloadFile,
  downloadOffersSummary,
} from './api-arval-back-office.service';
import { handleError } from './error-handler';
import { filenameDate } from './utils';

export const onDownloadReservationReport = async () => {
  return downloadReservationReport()
    .then((res) => {
      saveAs(res.data, `report_${filenameDate()}.xlsx`);
      return res;
    })
    .catch(handleError);
};

export const onDownloadBudget = async () => {
  return downloadFile('/BudgetCalculation/GetBudget', 'backoffice', 'blob')
    .then((res) => {
      saveAs(res.data, `budget_${filenameDate()}.xlsx`);
      return res;
    })
    .catch(handleError);
};

export const onDownloadMonthlyOffers = async () => {
  return downloadFile('/Reports/MonthlyOffers', 'backoffice', 'blob')
    .then((res) => {
      saveAs(res.data, `monthly_offers_${filenameDate()}.xlsx`);
      return res;
    })
    .catch(handleError);
};

export const downloadReport = async (registrationNumbers) => {
  return downloadOfferReport(registrationNumbers)
    .then((res) => {
      const blob = new Blob([res.data], {
        type: res.headers['content-type'],
      });

      saveAs(blob, `report_${filenameDate()}.csv`);
      return res;
    })
    .catch(handleError);
};

export const downloadSummary = async (indicator) => {
  return downloadOffersSummary(indicator)
    .then((res) => {
      const blob = new Blob([res.data], {
        type: res.headers['content-type'],
      });

      saveAs(blob, `report_${filenameDate()}.csv`);
      return res;
    })
    .catch(handleError);
};

export const draftsDownloader = async (userDataService, indicator) => {
  const countryId = userDataService?.activePointOfSales?.countryId;
  return downloadDrafts(countryId, indicator)
    .then((res) => {
      const blob = new Blob([res.data], {
        type: res.headers['content-type'],
      });
      saveAs(blob, `drafts_${filenameDate()}.csv`);
      return res;
    })
    .catch(handleError);
};
